import LandingPageTestimonials from '@/app/components/LandingPage/LandingPageTestimonials';

import sleepAndRestTestimonials from './data/sleepAndRestTestimonials';

const SleepAndRestTestimonials = (): JSX.Element => {
  return (
    <div data-cy="sleep-and-rest-testimonials" className="pt-10">
      <LandingPageTestimonials
        testimonials={sleepAndRestTestimonials}
        theme="blue"
        inverted
      />
    </div>
  );
};

export default SleepAndRestTestimonials;
